export const tinkYellow = {
  100: '#FFFBF4',
  200: '#FEF6E8',
  300: '#FFEFD3',
  400: '#FEE6BC',
  500: '#FED690',
  600: '#FECE7A ',
  700: '#FEAE22',
  800: '#B3770D',
  900: '#744B04',
};
